var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.126 10H4C2.887 10 2 10.895 2 12V15.73C2 17.04 3.874 17.783 6 17.96V14.996C6.00159 14.2012 6.3183 13.4395 6.88068 12.8779C7.44306 12.3162 8.2052 12.0005 9 12H9.354C8.7539 11.4711 8.32615 10.7745 8.126 10ZM15.874 10H20C21.105 10 22 10.885 22 12V15.73C22 17.04 20.126 17.783 18 17.96V14.996C17.9989 14.2011 17.6824 13.439 17.1199 12.8773C16.5574 12.3155 15.795 12 15 12H14.646C15.2461 11.4711 15.6738 10.7745 15.874 10ZM9.967 5.55401C9.87498 4.94306 9.59657 4.37542 9.16981 3.92865C8.74304 3.48188 8.18875 3.17777 7.58265 3.05787C6.97656 2.93797 6.34823 3.00813 5.7835 3.25876C5.21878 3.50939 4.74521 3.92826 4.4275 4.45816C4.10979 4.98805 3.96343 5.60312 4.00843 6.21932C4.05342 6.83552 4.28758 7.4228 4.67889 7.90092C5.07021 8.37904 5.59961 8.72468 6.19475 8.89062C6.78989 9.05655 7.42175 9.03469 8.004 8.82801C8.03235 8.16191 8.22679 7.51346 8.56962 6.94166C8.91246 6.36986 9.39282 5.89284 9.967 5.55401ZM15.997 8.82801C16.5792 9.0346 17.2109 9.05642 17.806 8.89051C18.401 8.72459 18.9304 8.37903 19.3217 7.90101C19.713 7.423 19.9471 6.83584 19.9922 6.21975C20.0373 5.60365 19.8911 4.98865 19.5736 4.45875C19.2561 3.92885 18.7828 3.50989 18.2182 3.25909C17.6537 3.0083 17.0255 2.9379 16.4194 3.0575C15.8133 3.17711 15.259 3.48089 14.832 3.92736C14.4051 4.37383 14.1264 4.94121 14.034 5.55201C14.6088 5.89068 15.0895 6.36793 15.4324 6.94018C15.7753 7.51243 15.9694 8.16146 15.997 8.82801Z",
    fill: "#7D7D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15C7 13.895 7.887 13 9 13H15C16.105 13 17 13.885 17 15V18.73C17 21.757 7 21.757 7 18.73V15Z",
    fill: "#7D7D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.6569 12 15 10.6569 15 9.00001C15 7.34316 13.6569 6.00001 12 6.00001C10.3431 6.00001 9 7.34316 9 9.00001C9 10.6569 10.3431 12 12 12Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleGroupIcon);
export default __webpack_public_path__ + "static/media/PeopleGroupIcon.c7a4fa233b2d5cc615df7abce70a56f1.svg";
export { ForwardRef as ReactComponent };